import React from 'react';
import ReactDOM from 'react-dom/client'

import App from './components/App'
import './styles/index.css'
import "./styles/reset.scss";
import "./styles/common.scss";


// document.addEventListener("DOMContentLoaded", () => {
//     setTimeout(() => {
//       ReactDOM.createRoot(document.getElementById('root')).render(
//         <React.StrictMode>
//           <App />
//         </React.StrictMode>
//       )
//     }, 2500);
//  });
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
